export default "__VITE_ASSET__D8E3H441__"